import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CellComponent } from '@shared/components/cell-components/cell-component';
import { Configuration } from '@shared/models/configuration';
import { FieldDefinition } from '@shared/models/field-definition';
import { SnackBarService } from '@core/services/snack-bar.service';
import { NotificationRelativePath } from '../../../constants/notification-relative-path';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'lib-file-name-cell-viewer',
  templateUrl: './alert-title-cell-viewer.component.html',
  styleUrls: ['./alert-title-cell-viewer.component.scss']
})
export class AlertTitleCellViewerComponent implements OnInit, CellComponent {
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  disabled: boolean;
  constructor(private router: Router, private snackBarService: SnackBarService) { }

  ngOnInit() {
  }

  isDisabled(): boolean {
    return Configuration.ApplicationId !== this.item.cells.Application.value;
  }

  onClickFileName() {
    if (this.isDisabled()) {
      this.snackBarService.showError('You can not edit notification of other applications');
      return;
    }
    this.router.navigate(NotificationRelativePath.getEditNotificationByAlertIdUrl(this.item.id));
  }
}
